import { forwardRef, useEffect, useState } from "react";
import Select from "react-select";
import CreatableSelect from 'react-select/creatable';
// includes
import { common } from "includes";
import { fetchOptions, peekOptions } from "./optionCache";

const FieldSelect = forwardRef((props: any, ref) => {
  // props
  const { render, placeholder, clearable, finder, size, auth, locality } = props;
  // state
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  // effect
  useEffect(() => {
    if (render === "empty") {
      setData([]);
      return;
    }
    if (render === "no") return;

    // A locality change can land while the previous list is still in flight;
    // whichever effect ran last owns the state.
    let live = true;
    const authKey = auth || "token";
    const cached = peekOptions(props.api, props.query, authKey);

    // Only clear and show the spinner when there is genuinely nothing to show.
    // Cached lists resolve in the same tick, and blanking them first is what
    // made revisited pickers flicker.
    if (!cached) {
      setData([]);
      setLoading(true);
    }

    fetchOptions(props.api, props.query, authKey).then((rows: any) => {
      if (!live) return;
      const selectData = common.SetMultiSelect(
        rows,
        props.get,
        props.set,
        props.join
      );
      setData(selectData);
      if (finder || props.value) {
        if (selectData && props.value) {
          if (typeof props.value === "object") {
            props?.onSelect(common.FindMultiSelect(selectData, props.value));
          } else {
            props?.onSelect(common.FindSelect(selectData, props?.value));
          }
        }
      }
      setLoading(false);
    });

    return () => {
      live = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [render, locality, props.api, props.query]);
  // handler
  const onChange = (value: any) => {
    props.onSelect(value);
  };

  return (
    props?.creatable ?
      <CreatableSelect
        menuPortalTarget={typeof document !== "undefined" ? document.body : undefined}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 1075 }) }}
        defaultValue={[]}
        isMulti={props.multi}
        value={props.finder ? null : props.value}
        options={data}
        className={size === "small" ? "basic-multi-select" : "custom-select-box"}
        classNamePrefix="react-select"
        isClearable={clearable}
        isLoading={loading}
        isDisabled={props.disabled}
        placeholder={loading ? "Loading data please wait..." : placeholder}
        onChange={(data) => onChange(data)} /> :
      <Select
        menuPortalTarget={typeof document !== "undefined" ? document.body : undefined}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 1075 }) }}
        defaultValue={[]}
        isMulti={props.multi}
        value={props.finder ? null : props.value}
        options={data}
        className={size === "small" ? "basic-multi-select" : "custom-select-box"}
        classNamePrefix="react-select"
        isClearable={clearable}
        isLoading={loading}
        isDisabled={props.disabled}
        placeholder={loading ? "Loading data please wait..." : placeholder}
        // menuPosition="fixed"
        onChange={(data) => onChange(data)}
      />
  );
});

export default FieldSelect;
